import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/model-training/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/model-training/datasets', replace: true })
  },
})
